(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tk-header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tk-menu-search')) {
class TkMenuSearch extends HTMLElement {
connectedCallback() {
if (this.input) return;
this.input = this.querySelector('.tkm__search-input');
this.clearBtn = this.querySelector('.tkm__search-clear');
this.results = this.querySelector('.tkm__results');
this.form = this.querySelector('form');
this.timer = null;
this.controller = null;
this.input.addEventListener('input', () => this.onInput());
this.clearBtn.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
this.input.addEventListener('keyup', (e) => {
if (e.key === 'Escape' && this.input.value) { e.stopPropagation(); this.input.value = ''; this.onInput(); }
});
}
esc(s) {
return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}
sized(url) {
if (!url) return '';
return url + (url.includes('?') ? '&' : '?') + 'width=120';
}
money(v) {
const n = parseFloat(v);
if (isNaN(n)) return '';
const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(n); }
catch (e) { return '$' + n.toFixed(2); }
}
onInput() {
const q = this.input.value.trim();
this.clearBtn.hidden = !q;
this.classList.toggle('is-searching', !!q);
clearTimeout(this.timer);
if (!q) { this.results.hidden = true; this.results.innerHTML = ''; return; }
this.timer = setTimeout(() => this.search(q), 220);
}
async search(q) {
if (this.controller) this.controller.abort();
this.controller = new AbortController();
const base = this.dataset.url || '/search/suggest';
const params = new URLSearchParams({
q,
'resources[type]': 'product,collection',
'resources[limit]': '6',
'resources[options][unavailable_products]': 'last',
'resources[options][fields]': 'title,product_type,variants.title,tag,vendor'
});
try {
const res = await fetch(`${base}.json?${params}`, { signal: this.controller.signal });
if (!res.ok) throw new Error(res.status);
const data = await res.json();
if (this.input.value.trim() !== q) return;
this.render(q, (data.resources && data.resources.results) || {});
} catch (e) {
if (e.name !== 'AbortError') this.results.hidden = true;
}
}
render(q, r) {
const products = r.products || [];
const cols = r.collections || [];
const searchUrl = `${this.form.getAttribute('action')}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
const thumb = (u) => u ? `<img src="${this.esc(this.sized(u))}" alt="" loading="lazy">` : '<span class="tkm__result-ph"></span>';
let html = '';
if (cols.length) {
html += '<p class="tkm__eyebrow tkm__results-label">Categories</p>';
html += cols.slice(0, 3).map((c) => `<a class="tkm__result" href="${this.esc(c.url)}">${thumb(c.featured_image && c.featured_image.url)}<span class="tkm__result-title">${this.esc(c.title)}</span></a>`).join('');
}
if (products.length) {
html += '<p class="tkm__eyebrow tkm__results-label">Products</p>';
html += products.map((p) => {
const img = (p.featured_image && p.featured_image.url) || p.image;
const price = p.price_min && p.price_max && p.price_min !== p.price_max ? `From ${this.money(p.price_min)}` : this.money(p.price);
return `<a class="tkm__result" href="${this.esc(p.url)}">${thumb(img)}<span><span class="tkm__result-title">${this.esc(p.title)}</span><span class="tkm__result-price">${this.esc(price)}</span></span></a>`;
}).join('');
}
if (!cols.length && !products.length) {
html = `<p class="tkm__result-empty">No matches for “${this.esc(q)}”. Try “steak”, “tuna” or “crab” — or call us and we’ll source it.</p>`;
}
html += `<a class="tkm__result-all" href="${searchUrl}">See all results for “${this.esc(q)}” <span aria-hidden="true">→</span></a>`;
this.results.innerHTML = html;
this.results.hidden = false;
}
}
customElements.define('tk-menu-search', TkMenuSearch);
}
  } catch(e) { console.error(e); }
})();

})();
